import { useEffect } from "react";

const upsert = (selector, attrs, value) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
};

export function useSEO(title, description, { image, url, type } = {}) {
  useEffect(() => {
    const ogImage = image || `${window.location.origin}/assets/og-default.png`;
    document.title = title;
    upsert('meta[name="description"]', { name: "description" }, description);
    upsert('meta[property="og:title"]', { property: "og:title" }, title);
    upsert('meta[property="og:description"]', { property: "og:description" }, description);
    upsert('meta[property="og:type"]', { property: "og:type" }, type || "website");
    upsert('meta[name="twitter:card"]', { name: "twitter:card" }, "summary_large_image");
    upsert('meta[name="twitter:title"]', { name: "twitter:title" }, title);
    upsert('meta[name="twitter:description"]', { name: "twitter:description" }, description);
    if (url) upsert('meta[property="og:url"]', { property: "og:url" }, url);
    upsert('meta[property="og:image"]', { property: "og:image" }, ogImage);
    upsert('meta[name="twitter:image"]', { name: "twitter:image" }, ogImage);
  }, [title, description, image, url, type]);
}
